import React, { useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";


export default function AmGauge({ value = 50, width = "100%", height = 180 }) {
  const chartRef = useRef(null);
  const axisItemRef = useRef(null);

  useEffect(() => {
    const root = am5.Root.new(chartRef.current);
    root._logo?.dispose();
    root.setThemes([am5themes_Animated.new(root)]);

    // -----------------------
    // Chart
    // -----------------------
    const chart = root.container.children.push(
      am5radar.RadarChart.new(root, {
        startAngle: 180,
        endAngle: 360,
        panX: false,
        panY: false
      })
    );

    //  allow needle to escape masking
    chart.set("maskBullets", false);

    // ensure needle renders above arc
    chart.bulletsContainer.set("layer", 20);

    
    // Axis Renderer (ARC)
    const axisRenderer = am5radar.AxisRendererCircular.new(root, {
      innerRadius: am5.percent(78),
      strokeWidth: 60,
      strokeOpacity: 1,
      minGridDistance: 17,
      strokeGradient: am5.LinearGradient.new(root, {
        rotation: 0,
        stops: [
           { offset: 0.0, color: am5.color(0xe53935) },
          { offset: 0.3, color: am5.color(0xe53935) },
          { offset: 0.4, color: am5.color(0xe53935) },
          { offset: 0.55, color: am5.color(0xfb8c00) },
          { offset: 0.8, color: am5.color(0xfb8c00) },
          { offset: 1.0, color: am5.color(0x43a047) }
        ]
      })
    });

    // remove inner ticks & grid lines
    axisRenderer.ticks.template.setAll({ visible: false });
    axisRenderer.grid.template.setAll({ visible: false });

    axisRenderer.labels.template.setAll({
      fontSize: 10,
      fontWeight: "700",
      radius: 17,
      fill: am5.color(0x000000)
    });

    // Axis
    const xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        max: 100,
        strictMinMax: true,
        renderer: axisRenderer
      })
    );

    const allowedValues = [0, 20, 40, 60, 80, 100];
    const valueLabels = {
      0: "        Poor",
      20: "",
      40: "Bad ",
      60: "Average",
      80: "Good",
      100: "Excellent"
    };
    axisRenderer.labels.template.adapters.add("text", (_, target) => {
      const v = target.dataItem?.get("value");
      return allowedValues.includes(v) ? valueLabels[v] : "";
    });


axisRenderer.labels.template.adapters.add("rotation", (rotation, target) => {
  const v = target.dataItem?.get("value");
  return v === 40 ? -22 : rotation;
});


axisRenderer.labels.template.adapters.add("rotation", (rotation, target) => {
  const v = target.dataItem?.get("value");
  return v === 60 ? -18 : rotation;
});

axisRenderer.labels.template.adapters.add("rotation", (rotation, target) => {
  const v = target.dataItem?.get("value");
  return v === 80 ? -15 : rotation;
});

axisRenderer.labels.template.adapters.add("rotation", (rotation, target) => {
  const v = target.dataItem?.get("value");
  return v === 100 ? -10.8 : rotation;
});

    // Clock Hand (NEEDLE)
    const clockHand = am5radar.ClockHand.new(root, {
      radius: am5.percent(110), // NORMAL length (not extended)
      topWidth: 0.1,
      bottomWidth: 8,
      pinRadius: 7

    });

    // Needle colors (use your existing ones if already defined)
 const NEEDLE_FILL = am5.color(0x2B2B2B); // soft black
const NEEDLE_BORDER = am5.color(0x000000); // darker border

// Small triangle at the needle tip
const tipTriangle = am5.Triangle.new(root, {
  width: 8,
  height: 8,
  fill: NEEDLE_FILL,
  stroke: NEEDLE_BORDER,
  strokeWidth: 1,
  centerX: am5.percent(50),
  centerY: am5.percent(100),
  dy: -5
});

    // pink needle
    clockHand.hand.setAll({
  fill: NEEDLE_FILL,
  stroke: NEEDLE_BORDER,   //  border color
  strokeWidth: 2,          //  border thickness
  shadowColor: NEEDLE_BORDER
});

    // center pin
    clockHand.pin.setAll({
  fill: NEEDLE_FILL,
  stroke: NEEDLE_BORDER,
  strokeWidth: 0.8
});

    const axisDataItem = xAxis.makeDataItem({});
    axisDataItem.set("value", 0);

    axisDataItem.set(
      "bullet",
      am5xy.AxisBullet.new(root, {
        sprite: clockHand
      })
    );

    xAxis.createAxisRange(axisDataItem);
    axisDataItem.get("grid").set("visible", false);
    axisItemRef.current = axisDataItem;
    
    root.events.once("frameended", () => {
  chart.bulletsContainer.children.moveValue(
    clockHand,
    chart.bulletsContainer.children.length - 1
  );
});

    axisDataItem.animate({
      key: "value",
      to: value,
      duration: 900,
      easing: am5.ease.out(am5.ease.cubic)
    });

    chart.appear(600, 100);

    return () => root.dispose();
  }, []);

 
  // Update animation

  useEffect(() => {
    if (axisItemRef.current) {
      axisItemRef.current.animate({
        key: "value",
        to: value,
        duration: 700,
        easing: am5.ease.out(am5.ease.cubic)
      });
    }
  }, [value]);

  return (
    <div style={{ width, height }}>
      <div ref={chartRef} style={{ width: "100%", height: "100%" }} />
    </div>
  );
}
